import { Box, BoxProps, CircularProgress, CircularProgressProps } from '@mui/material'
import { FC } from 'react'
import { LabeledTextField } from '@omnea-app/frontend/components/shared/form/inputs/labeled/LabeledTextField'

interface FullWidthLoadingFallbackProps extends BoxProps {
  color?: CircularProgressProps['color']
}

export const FullWidthLoadingFallback: FC<FullWidthLoadingFallbackProps> = ({ sx, color = 'secondary', ...props }) => (
  <Box
    {...props}
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 4,
      ...sx,
    }}
  >
    <CircularProgress color={color} />
  </Box>
)

interface IconLoadingFallbackProps {
  size?: number
}

export const IconLoadingFallback: FC<IconLoadingFallbackProps> = ({ size = 20 }) => (
  <CircularProgress color="secondary" size={size} />
)

export const IconButtonLoadingFallback: FC = () => (
  <div style={{ padding: 5, display: 'flex' }}>
    <IconLoadingFallback size={24} />
  </div>
)

interface TextInputLoadingFallbackProps {
  label: string
}

export const TextInputLoadingFallback: FC<TextInputLoadingFallbackProps> = ({ label }) => (
  <Box sx={{ width: '400px' }}>
    <LabeledTextField label={label} disabled />
  </Box>
)
